import { render } from "./tablesarana.vue?vue&type=template&id=1793bdb0"
import script from "./tablesarana.vue?vue&type=script&lang=js"
export * from "./tablesarana.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__